import { render, staticRenderFns } from "./Trazabilidad_Dia.vue?vue&type=template&id=24938745&scoped=true&"
import script from "./Trazabilidad_Dia.vue?vue&type=script&lang=js&"
export * from "./Trazabilidad_Dia.vue?vue&type=script&lang=js&"
import style0 from "./Trazabilidad_Dia.vue?vue&type=style&index=0&id=24938745&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24938745",
  null
  
)

export default component.exports